package one.healthium.promo_banner.ui

import androidx.compose.runtime.Immutable

@Immutable
data class PromoBannerUiState(
    val bannerData: PromoBannerData? = null
)
